import Vue from "vue";
import moment from "moment";

Vue.directive("data-hora-br", (el, binding) => {
  let newDate   = moment(binding.value, 'DD/MM/YYYY HH:mm:ss');
  binding.value = newDate.subtract(0, "hours").format("DD/MM/YYYY HH:mm");
  el.innerText  = binding?.value;
});
